import { Pipe, PipeTransform } from '@angular/core';
import { DateUtilsService } from '../services/date-utils/date-utils.service';
import { FormatUtilsService } from '../services/format-utils/format-utils.service';

@Pipe({
  name: 'dynamicFormat',
})
export class DynamicFormatPipe implements PipeTransform {
  constructor(
    private dateUtils: DateUtilsService,
    private formatUtilsService: FormatUtilsService,
  ) {}

  private readonly ENUM_LABELS: Record<string, string> = {
    PENDENTE_ANALISE: 'Pendente análise',
    EM_ANALISE: 'Em análise',
    APROVADO: 'Aprovado',
    REJEITADO: 'Rejeitado',
    PENDENTE_VINCULO: 'Pendente vínculo',
    // Terminais (bilhetagem-api): tipo e status
    TERMINAL: 'Terminal',
    ESTACAO_TRANSFERENCIA: 'Estação de transferência',
    ACTIVE: 'Ativo',
    INACTIVE: 'Inativo',
  };

  private readonly FORMATTING_RULES = [
    {
      // Enums de domínio (status, tipo…)
      match: (col: string, val: any) =>
        typeof val === 'string' && val in this.ENUM_LABELS,
      format: (val: string) => this.ENUM_LABELS[val],
    },
    {
      // Date
      match: (col: string, val: any) =>
        typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val),
      format: (val: string) => this.dateUtils.formatISOToDate(val),
    },
    {
      // Datetime
      match: (col: string, val: any) =>
        typeof val === 'string' &&
        /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?Z?$/.test(val),
      format: (val: string) => this.dateUtils.formatISOToDateReadable(val),
    },
    {
      // CPF
      match: (col: string, val: any) =>
        typeof val === 'string' && col.toLowerCase().includes('cpf'),
      format: (val: string) => this.formatUtilsService.formatCpf(val),
    },
    {
      // CNPJ
      match: (col: string, val: any) =>
        typeof val === 'string' && col.toLowerCase().includes('cnpj'),
      format: (val: string) => this.formatUtilsService.formatCnpj(val),
    },
    {
      // Fone
      match: (col: string, val: any) =>
        typeof val === 'string' && col.toLowerCase().includes('fone'),
      format: (val: string) => this.formatUtilsService.formatPhoneNumber(val),
    },
  ];

  transform(value: any, columnKey: string = ''): string {
    if (value === null || value === undefined || value === '') {
      return 'Sem valor';
    }

    const rule = this.FORMATTING_RULES.find((r) => r.match(columnKey, value));

    return rule ? rule.format(value) : String(value);
  }
}
